import React from 'react';
export function Sale() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-528">
      <div className="max-w-[1800px] mx-auto" data-id="element-529">
        <header className="mb-20 text-center" data-id="element-530">
          <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-red-600" data-id="element-531">
            Limited Opportunity
          </span>
          <h1 className="text-4xl md:text-6xl font-display font-bold tracking-[0.2em] uppercase mb-6" data-id="element-532">
            Sale
          </h1>
          <p className="max-w-xl mx-auto text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-533">
            Exclusive pieces from previous collections at exceptional value.
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-534">
          {[1, 2, 3, 4].map(i => <div key={i} className="group cursor-pointer" data-id="element-535">
              <div className="aspect-[3/4] bg-grey-divider overflow-hidden mb-4 relative" data-id="element-536">
                <div className="absolute top-4 left-4 bg-red-600 text-white text-[8px] font-display font-bold px-2 py-1 tracking-widest uppercase z-10" data-id="element-537">
                  30% OFF
                </div>
                <div className="w-full h-full bg-black/5 group-hover:bg-black/10 transition-colors" data-id="element-538" />
              </div>
              <h3 className="text-[11px] font-display font-bold tracking-widest uppercase mb-1" data-id="element-539">
                Sale Item {i}
              </h3>
              <p className="text-xs font-light" data-id="element-540">
                <span className="line-through text-black/30 mr-2" data-id="element-541">$350</span>{' '}
                $245
              </p>
            </div>)}
        </div>
      </div>
    </div>;
}